package com.eladfinish.bible.contest.screens.main.data

enum class ItemMode {
    REGULAR,
    DRAGGABLE,
}
